export default __webpack_public_path__ + "static/media/hiw_1.616ae1de.svg";